import React from "react";
import { DeveloperTrack } from "./types";
import { DeveloperTrackActivityProvider } from "./context/developer-track-activity.context";
import { ActivityScrollProvider } from "@/modules/lead-page/new/context/activity-scroll-context";
import ActivityTab from "@/modules/lead-page/new/components/activity/activity-tab";
import AddDeveloperTrackComment from "./add-developer-track-comment";

interface TrackActivityProps {
  track: DeveloperTrack;
}

const TrackActivity: React.FC<TrackActivityProps> = ({ track }) => {
  return (
    <DeveloperTrackActivityProvider trackUId={track.trackUId}>
      <ActivityScrollProvider>
        <ActivityTab
          addComment={<AddDeveloperTrackComment trackUId={track.trackUId} />}
          isHeaderCollapsed={false}
        />
      </ActivityScrollProvider>
    </DeveloperTrackActivityProvider>
  );
};

export default TrackActivity;
